import Listing from 'app/shared/model/Listing';
import KeyPager from 'app/shared/model/KeyPager';

const Listings = ({
    listings = [],
    maintenancePartner = {},
    numActiveListings = 0,
    numInactiveListings = 0,
    numTotalListings = 0,
    statsDaysBack = 0,
    pager = {},
    restrictions = {},
    feedClaimAndConvertUpdate = {},
} = {}) => ({
    listings: listings.map(item => Listing(item)),
    maintenancePartner: Object(maintenancePartner),
    feedClaimAndConvertUpdate: Object(feedClaimAndConvertUpdate),
    numActiveListings: Number(numActiveListings),
    numInactiveListings: Number(numInactiveListings),
    numTotalListings: Number(numTotalListings),
    statsDaysBack: Number(statsDaysBack),
    pager: KeyPager(pager),
    restrictions: Object(restrictions),
});

export default Listings;
